<template lang="pug">
.estado-erro
  slot(:mensagemDeErro="mensagemDeErro")
    .estado-erro-padrao
      img.estado-erro-padrao__icone(src="../../../static/icones/emojiTriste.svg")
      .estado-erro-padrao__texto
        p.estado-erro-padrao__titulo {{ $t('compartilhados.SmartTable.EstadoErro.mensagemErro') }}
        span.estado-erro-padrao__detalhe {{ mensagemDeErro }}
        p.estado-erro-padrao__descricao(v-if="descricao") {{ descricao }}
      .estado-erro-padrao__acao(v-if="$slots.acao")
        slot(name="acao")
</template>

<script>
export default {
  name: 'EstadoErro',
  props: {
    mensagemDeErro: {
      type: String,
      required: true
    },
    // Microcopy de orientação (próximo passo). Opcional — quando omitido, nada
    // é exibido. Ex.: "Tente recarregar a página ou contate o suporte."
    descricao: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.estado-erro {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);

  &-padrao {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;

    &__icone {
      width: 50px;
      opacity: 0.7;
    }

    &__texto {
      text-align: center;
      display: flex;
      flex-direction: column;
      gap: 0.375rem;
    }

    &__titulo {
      color: var(--texto-forte);
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
    }

    &__detalhe {
      color: var(--texto-suave);
      font-size: 0.875rem;
    }

    &__descricao {
      color: var(--texto-suave);
      margin: 0;
      font-size: 0.875rem;
    }

    &__acao {
      margin-top: 0.25rem;
    }
  }
}
</style>
